import { Link } from 'react-router-dom';
import { hasAdminAccess } from '@wineryxplorer/shared';
import { Avatar } from '../Avatar';
import { adminMenuItems, moreMenuItems } from './navConfig';
import type { SessionUser } from '@wineryxplorer/shared';

interface MobileMenuPanelProps {
  user: SessionUser | null | undefined;
  getMobileNavLinkClasses: (path: string) => string;
  onLogout: () => void;
  isLoggingOut: boolean;
}

/**
 * The `lg:hidden` slide-down nav panel behind the hamburger button.
 * Presentational only — all open/close state stays in `Layout`.
 */
export const MobileMenuPanel = ({
  user,
  getMobileNavLinkClasses,
  onLogout,
  isLoggingOut,
}: MobileMenuPanelProps) => (
  <div className="lg:hidden" id="mobile-menu">
    <div className="pt-2 pb-3 space-y-1">
      <Link to="/wineries" className={getMobileNavLinkClasses('/wineries')}>
        Wineries
      </Link>
      <Link to="/experiences" className={getMobileNavLinkClasses('/experiences')}>
        Experiences
      </Link>
      <Link to="/events" className={getMobileNavLinkClasses('/events')}>
        Events
      </Link>
      <Link to="/itineraries" className={getMobileNavLinkClasses('/itineraries')}>
        Itineraries
      </Link>
      <div className="px-4 pt-3 pb-1 text-xs font-semibold uppercase tracking-wide text-gray-500">
        More
      </div>
      {moreMenuItems.map((item, index) =>
        'hr' in item ? (
          <div
            key={`hr-${index}`}
            className="my-1 mx-4 border-t border-gray-200"
            role="separator"
          />
        ) : (
          <Link
            key={item.path}
            to={item.path}
            className={getMobileNavLinkClasses(item.path)}
          >
            {item.label}
          </Link>
        )
      )}
      {user && hasAdminAccess(user.role) && (
        <>
          {adminMenuItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={getMobileNavLinkClasses(item.path)}
            >
              {item.label}
            </Link>
          ))}
        </>
      )}
    </div>
    {user && (
      <div className="pt-3 pb-3 border-t border-gray-200">
        <Link
          to="/profile"
          className="flex items-center pl-3 pr-4 py-2 text-base font-semibold text-gray-700 hover:bg-gray-100 hover:text-gray-900"
        >
          <Avatar user={user} size="sm" className="mr-3" />
          My Profile
        </Link>
        <button
          onClick={onLogout}
          disabled={isLoggingOut}
          className="block w-full text-left pl-3 pr-4 py-2 text-base font-semibold text-error hover:bg-gray-100 cursor-pointer bg-transparent border-none"
        >
          {isLoggingOut ? 'Logging out...' : 'Logout'}
        </button>
      </div>
    )}
    {!user && (
      <div className="pt-3 pb-3 border-t border-gray-200">
        <Link
          to="/login"
          className="block px-4 py-2 text-lg font-semibold text-primary-700 hover:bg-gray-100"
        >
          Sign In
        </Link>
      </div>
    )}
  </div>
);
